import { Component } from '@angular/core';
import {
  MenuList,
  AccountsLayoutComponent,
} from '../../../shared/components/accounts-layout/accounts-layout.component';

@Component({
  selector: 'app-admin',
  standalone: true,
  templateUrl: './admin.component.html',
  styleUrl: './admin.component.scss',
  imports: [AccountsLayoutComponent],
})
export class AdminComponent {
  menuList: MenuList = {
    menuSubLists: [
      {
        title: {
          icon: '',
          iconType: '',
          label: 'quick access',
          route: '',
        },
        items: [
          {
            icon: 'group',
            iconType: 'svgIcon',
            label: 'Dashboard',
            route: 'dashboard',
          },
          {
            icon: 'event',
            iconType: 'matIcon',
            label: 'Meetings',
            route: 'meeting-portal'
          },
        ],
      },
      {
        title: {
          icon: '',
          iconType: '',
          label: 'user management',
          route: '',
        },
        items: [
          {
            icon: 'group',
            iconType: 'svgIcon',
            label: 'Users',
            route: 'users',
          },
          {
            icon: 'group',
            iconType: 'svgIcon',
            label: 'Roles',
            route: 'roles',
          },
          {
            icon: 'dashboard',
            iconType: 'svgIcon',
            label: 'LDAP',
            route: 'ldaps',
          },
          {
            icon: 'account_balance',
            iconType: 'svgIcon',
            label: 'Institutions',
            route: 'institutions',
          },
          {
            icon: 'help_desk',
            iconType: 'svgIcon',
            label: 'FAQs',
            route: 'faqs',
          },
          {
            icon: 'info_request',
            iconType: 'svgIcon',
            label: 'User Manual',
            route: 'user-manual-management',
          },
        ],
      },
      // {
      //   title: {
      //     icon: '',
      //     iconType: '',
      //     label: 'plan management',
      //     route: '',
      //   },
      //   items: [
      //     {
      //       icon: 'workspace_premium',
      //       iconType: 'svgIcon',
      //       label: 'Subscription Plans',
      //       route: 'plans',
      //     },
      //   ],
      // },
      {
        title: {
          icon: '',
          iconType: '',
          label: 'Settings',
          route: '',
        },
        items: [
          {
            icon: 'storage',
            iconType: 'matIcon',
            label: 'Instances',
            route: 'instances',
          }
        ],
      },
      {
        title: {
          icon: '',
          iconType: '',
          label: 'feedback & reports',
          route: '',
        },
        items: [
          {
            icon: 'comment',
            iconType: 'svgIcon',
            label: 'Feedbacks',
            route: 'feedback',
          },
          {
            icon: 'bar_chart',
            iconType: 'matIcon',
            label: 'Reports',
            route: 'reports'
          },
          // {
          //   icon: 'bar_chart',
          //   iconType: 'matIcon',
          //   label: 'Meeting Reports',
          //   route: 'meetings-portal',
          // },
          
          
        ],
      },
    ],
  };
}
